import styled from 'styled-components';
import { ButtonsWrapper } from '../../components/Button/ButtonStyledComponent';
import { TextBold, TextRegular } from '../../styles/GlobalStyledComponents';
import { TextMedium } from './../../styles/GlobalStyledComponents';
import { InfoCardMiniSpan } from '../../components/CardInputs/CardsStyledComponents';

interface PaymentProps {
  responsiveHidden?: boolean;
}

interface ModalProps {
  open?: boolean;
}

export const PaymentWrapper = styled.div`
  width: 100%;
`;

export const PaymentView = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* gap: 15px; */
`;

interface PaymentSectionProps {
}

export const PaymentHeader = styled.div<PaymentSectionProps>`
  height: 100%;
  background-color: ${(props) => props.theme.colors.white};
  padding: 16px;
  margin: 0 0 15px 0;
  border-radius: 16px;
  box-shadow: 0px 0px 16px rgba(8, 84, 117, 0.08);
  align-items: center;
  max-width: 700px;
  width: 100%;

  @media (min-width: 601px) and (max-width: 650px) {
    margin: 0 30px;
    width: auto;
  }

  @media (max-width: 650px) {
    position: relative;
    padding-bottom: 16px;
  }
`;

export const AmountCurrency = styled(TextRegular)`
  margin-left: 3px;

  @media (max-width: 500px) {
    margin-top: 3px;
  }
`;

export const SelectPaymentLink = styled(TextRegular)`
  color: ${(props) => props.theme.colors.gray6};
`;

export const MoneyWrapper = styled.div``;

export const Cards = styled.div`
  width: 100%;
  max-width: 540px;
  @media (max-width: 500px) {
    padding: 0 15px;
  }
`;

export const PaymentCard = styled.div`
  padding: 0 10px;
  margin: 15px 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 540px;
  min-height: 52px;
  border: solid 1px #e3e1e1;
  border-radius: 8px;
  cursor: pointer;

  :hover {
    background-color: #f5fbfe;
    border: solid 1px #7cb6c0;
  }
`;

export const ButtonCheckbox = styled.input`
  margin-right: 5px;
  width: 25px;
  height: 25px;
  appearance: none;
  border: solid 1px #e3e1e1;
  border-radius: 50%;

  &:checked {
    background-image: url('/optionChecked.svg');
    background-repeat: no-repeat;
    background-position: center;
  }
`;

export const PaymentIcon = styled.img<PaymentProps>`
  margin-right: 5px;

  @media (max-width: 500px) {
    display: ${(props) => (props.responsiveHidden ? 'none' : 'initial')};
  }
`;

export const PaymentCardTitle = styled(TextBold)``;

export const AmountTitle = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
`;

export const PaymentSection = styled.div`
  width: 100%;
  padding: 8px 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

export const PaymentInformation = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const PaymentInformationRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 32px;

  @media (max-width: 650px) {
    justify-content: space-between;
    gap: 8px;
  }

  @media (max-width: 350px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const AmountColumn = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const EditOptionText = styled(TextMedium)`
  color: ${(props) => props.theme.colors.red4};
  cursor: pointer;
`;

export const ButtonSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  max-width: 700px;
  padding: 10px;
  margin: 0 auto;
  position: relative;
  bottom: 0;
  left: 0;

  @media (max-width: 850px) {
    max-width: 100%;
    position: fixed;
    z-index: 99;
    box-shadow: 0px 0px 16px rgba(8, 84, 117, 0.08);
    background-color: #fff;
    flex-direction: column-reverse;
    border-radius: 16px 16px 0px 0px;
  }
`;

export const ButtonsWrapperPayment = styled(ButtonsWrapper)`
  @media (max-width: 850px) {
    max-width: 100%;
    padding: 0px;
  }
`;

export const ButtonsWrapperBizum = styled(ButtonsWrapper)`
  z-index: 1;

  button {
    min-height: 50px;
  }

  @media (max-width: 850px) {
    padding: 10px 0px;
  }
`;

export const Button = styled.button`
  border: none;
  margin: 10px 5px;
  min-height: 50px;
  padding: 10px;
  border-radius: 8px;
  max-width: 260px;
  width: 100%;
  gap: 15px;
  cursor: pointer;
`;

export const ReturnButton = styled(Button)`
  background-color: ${(props) => props.theme.colors.bgGray};
  color: ${(props) => props.theme.colors.gray6};
  border: solid 1px ${(props) => props.theme.colors.gray6};
  font-weight: ${(props) => props.theme.fontWeight.textMedium};
`;

export const ContinueButton = styled(Button)`
  background-color: ${(props) => props.theme.colors.red4};
  color: #fff;
  font-weight: ${(props) => props.theme.fontWeight.textMedium};
`;

export const PaymentModal = styled.div<ModalProps>`
  display: ${(props) => (props.open ? 'block' : 'none')};
  height: 500px;
  width: 400px;
  position: fixed;
  background-color: white;
  border: solid 1px gray;
  z-index: 99;
  top: 15%;
  @media (max-width: 500px) {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export const PaymentOverlay = styled.div<ModalProps>`
  display: ${(props) => (props.open ? 'block' : 'none')};
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 98;
  cursor: pointer;
`;

export const TitleSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 10px;
`;

export const AmountChangeButtonSection = styled.div`
  display: flex;
  min-width: 130px;

  @media (max-width: 650px) {
    position: absolute;
    bottom: 6px;
    left: 15px;

    button {
      justify-content: unset;
      padding-left: 0px;
    }
  }

  @media (max-width: 350px) {
    bottom: -5px;
  }
`;

export const InfoCardPaymentPlan = styled(InfoCardMiniSpan)`
  display: flex;
  align-items: none;
  gap: 4px;
  height: 32px;
`;

export const PaymentPlanTextMedium = styled(TextMedium)`
  margin-top: 2px;
`;

export const PaymentPlanTextBold = styled(TextBold)`
  margin-top: 3px;
`;